import SimpleDropdown, {
  SimpleDropdownProps
} from './SimpleDropdown.component';

export type { SimpleDropdownProps };
export default SimpleDropdown;
